const localUrl = "http://localhost:3000";
const isLocalServer = window.location.origin === localUrl;

/** api url */
export const serverUrl = isLocalServer ? process.env.REACT_APP_NODE_SERVER_DEV :  process.env.REACT_APP_NODE_SERVER;

/** file base url  */
export const filepath = isLocalServer ? process.env.REACT_APP_FILE_PATH_DEV :  process.env.REACT_APP_FILE_PATH;

/** google web client id */
export const clientId = process.env.REACT_APP_GOOGLE_WEB_CLIENT;

/** file server url */
export const fileServer = isLocalServer ? process.env.REACT_APP_FILE_SERVER_DEV :  process.env.REACT_APP_FILE_SERVER;
